import { startAuth } from "./storage.js";

export default function Login() {
  return (
    <div style={{
      fontFamily: "'IBM Plex Sans',system-ui,sans-serif",
      background: "#080c14", minHeight: "100vh",
      display: "flex", alignItems: "center", justifyContent: "center",
      color: "#b8c4dc", padding: 24
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');
      `}</style>

      <div style={{
        width: 440, padding: "40px 44px",
        background: "#0a0e18", border: "1px solid #0f1825",
        borderRadius: 16, boxShadow: "0 30px 80px rgba(0,0,0,.5)"
      }}>
        {/* Logo */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 28 }}>
          <div style={{
            width: 44, height: 44,
            background: "linear-gradient(135deg,#1d4ed8,#1e40af)",
            borderRadius: 11, display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 22, fontWeight: 700, color: "#93c5fd"
          }}>TT</div>
          <div>
            <div style={{ fontWeight: 600, fontSize: 21, color: "#e2e8f0", letterSpacing: "-.3px" }}>StockTrade</div>
            <div style={{ fontSize: 12, color: "#1e3a5f", fontFamily: "'IBM Plex Mono',monospace", letterSpacing: "1px", textTransform: "uppercase", marginTop: 2 }}>Portfolio Tracker · IDX · US</div>
          </div>
        </div>

        <div style={{ fontSize: 16, color: "#9ca3af", marginBottom: 8, fontWeight: 500 }}>
          Welcome back
        </div>
        <div style={{ fontSize: 14, color: "#6b7280", marginBottom: 24, lineHeight: 1.7 }}>
          Your portfolio data is stored securely in <b style={{color:"#60a5fa"}}>your own Dropbox</b> — 
          we never see it. Sign in with Dropbox to access or create your account.
        </div>

        <button
          onClick={startAuth}
          style={{
            width: "100%", padding: "13px 16px",
            background: "#0061FE",
            border: "none", borderRadius: 9,
            color: "white", fontWeight: 600, fontSize: 16,
            cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
            fontFamily: "'IBM Plex Sans',system-ui",
            transition: "background .15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#0052d6"}
          onMouseLeave={e => e.currentTarget.style.background = "#0061FE"}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M7.2 1.8L0 6.6l7.2 4.8L14.4 6.6 7.2 1.8zM16.8 1.8L9.6 6.6l7.2 4.8L24 6.6l-7.2-4.8zM0 16.2l7.2 4.8 7.2-4.8L7.2 11.4 0 16.2zM16.8 11.4l-7.2 4.8 7.2 4.8L24 16.2l-7.2-4.8z" fill="white"/>
          </svg>
          Sign in with Dropbox
        </button>

        <div style={{ marginTop: 22, padding: "10px 12px", background: "rgba(59,130,246,.04)", border: "1px solid rgba(59,130,246,.12)", borderRadius: 8, fontSize: 13, color: "#6b7280", lineHeight: 1.8 }}>
          <b style={{color:"#60a5fa"}}>How it works:</b><br />
          • Your data lives in <code style={{color:"#a78bfa"}}>Dropbox/Apps/StockTrade/</code><br />
          • We only access that folder — nothing else in your Dropbox<br />
          • Access from any device by logging in here
        </div>

        <div style={{ marginTop: 16, textAlign: "center", fontSize: 12, color: "#374151" }}>
          Don't have Dropbox? <a href="https://dropbox.com/register" target="_blank" rel="noopener" style={{color:"#60a5fa",textDecoration:"none"}}>Create a free account →</a>
        </div>
      </div>
    </div>
  );
}
